export default "__VITE_ASSET__2b0e3669__"